import React from 'react';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { ProductCard } from '../components/ProductCard';
import { Testimonials } from '../components/Testimonials';
import { useProducts } from '../context/ProductContext';
import { Link } from 'react-router-dom';
import { ArrowRight, Loader } from 'lucide-react';
import { BenefitGrid } from '../components/Benefits';
import { SEO } from '../components/SEO';
import { 
  AboutSection, 
  StatsSection, 
  ServicesSection,
  MufasaProtocolSection, 
  PricingSection, 
  OrderSection 
} from '../components/MarketingSections';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.simbaherbals.com';

export const Home = () => {
  const { products, loading } = useProducts();

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Simba Herbals UK',
    url: SITE_URL,
    logo: `${SITE_URL}/logo/simba-HERBALS-Logo_hres-1024x321.webp`,
    description: 'Premium 100% natural African herbal support for men\'s vitality. The Mufasa Protocol with discreet UK shipping.',
    address: { '@type': 'PostalAddress', streetAddress: '50 Victoria Street', addressLocality: 'Wolverhampton', postalCode: 'WV1 3PJ', addressCountry: 'GB' },
    contactPoint: { '@type': 'ContactPoint', telephone: '+44-7724-009805', contactType: 'customer service', areaServed: 'GB' },
  };
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Simba Herbals UK',
    url: SITE_URL,
    description: 'Unleash the beast with Simba Herbals UK. Premium 100% natural African herbal support for men\'s vitality.',
    potentialAction: { '@type': 'SearchAction', target: `${SITE_URL}/shop`, 'query-input': 'required name=search_term_string' },
  };
  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Simba Herbals UK | Pure Mufasa Energy | Natural Men\'s Wellness',
    url: SITE_URL,
    description: 'Unleash the beast with Simba Herbals UK. Premium 100% natural African herbal support for men\'s vitality. Discover the Mufasa Protocol with discreet UK shipping.',
    isPartOf: { '@type': 'WebSite', url: SITE_URL },
  };

  return (
    <div className="overflow-x-hidden">
      <SEO
        title="Simba Herbals UK | Pure Mufasa Energy | Natural Men's Wellness"
        description="Unleash the beast with Simba Herbals UK. Premium 100% natural African herbal support for men's vitality. Discover the Mufasa Protocol with discreet UK shipping."
        canonical="/"
        jsonLd={[organizationJsonLd, websiteJsonLd, webPageJsonLd]}
      />
      <Hero />
      <StatsSection />
      <Marquee />

      <AboutSection />
      
      {/* Featured Products (Kept as is) */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
           <div className="flex justify-between items-end mb-12">
              <div>
                <h2 className="font-display text-3xl lg:text-4xl text-simba-dark mb-2">The Mufasa Collection</h2>
                <div className="h-1 w-20 bg-simba-gold rounded-full"></div>
              </div>
              <Link to="/shop" className="hidden md:flex items-center font-bold text-simba-green hover:text-simba-dark transition-colors">
                 View All Products <ArrowRight size={20} className="ml-2" />
              </Link>
           </div>
           
           {loading ? (
             <div className="flex justify-center py-20 text-simba-green">
                <Loader className="animate-spin mr-2" /> Loading Products...
             </div>
           ) : (
             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {products.slice(0, 3).map(product => (
                   <ProductCard key={product.id} {...product} />
                ))}
             </div>
           )}

           <div className="mt-12 text-center md:hidden">
              <Link to="/shop" className="btn-primary inline-flex">View All Products</Link>
           </div>
        </div>
      </section>

      <ServicesSection />

      <MufasaProtocolSection />

      <BenefitGrid />
      
      <PricingSection />

      <OrderSection />
      
      <Testimonials />
    </div>
  );
};

